package nl.volleyplanner.api.client.planner

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import nl.volleyplanner.api.entities.PersonId
import nl.volleyplanner.api.planner.Ruleset
import nl.volleyplanner.api.planner.SetLockRequest
import nl.volleyplanner.api.planner.Task
import nl.volleyplanner.api.planner.UpdateAssigneeRequest

class TasksClientEndpoint(val httpClient: HttpClient, prefix: String) {
    val base = "$prefix/task"

    suspend fun getTaskConstraints(task: Task) : Ruleset {
        return httpClient.get("$base/${task.id}/constraints").body()
    }

    suspend fun updateAssignee(task: Task, personId: PersonId?) {
        httpClient.post("$base/${task.id}/update-assignee") {
            contentType(ContentType.Application.Json)
            setBody(UpdateAssigneeRequest(task.id, personId))
        }
    }

    suspend fun setTaskLock(task: Task, locked: Boolean) {
        httpClient.post("$base/${task.id}/set-lock") {
            contentType(ContentType.Application.Json)
            setBody(SetLockRequest(task.id, locked))
        }
    }
}